<template>
  <Layout footer>
    <NSpin :show="initLoading" :class="{ 'py-40': initLoading }">
      <div class="app-container" v-show="!initLoading">
        <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
          <span class="mr-1">当前位置：</span>
          <NBreadcrumb>
            <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
            <NBreadcrumbItem>学习中心</NBreadcrumbItem>
            <NBreadcrumbItem>教材领用</NBreadcrumbItem>
          </NBreadcrumb>
        </div>
        <div class="mt-7 p-10 border border-gray-300">
          <div class="flex items-start pb-28 border-b-2 border-dashed border-gray-300">
            <img style="width: 225px" class="flex-shrink-0" :src="imgBaseUrl + userInfo.photo" alt="头像信息" />
            <div class="ml-20">
              <p class="text-xl">{{ userInfo.stuName }}</p>
              <p class="mt-4 text-gray-500 text-base"> 机构：{{ userInfo.tenantName }} </p>
              <p class="mt-2 text-gray-500 text-base">班级：{{ userInfo.className }}</p>
              <p class="mt-2 text-gray-500 text-base">班主任：{{ userInfo.headTeacherName }}</p>
              <p class="mt-4 text-base" style="color: #DF1A23">
                领用时间：{{ userInfo.teachingMaterialsDate || '-' }}
              </p>
            </div>
            <n-button type="primary" class="ml-auto">
              {{ flag ? '未领用' : '已领用' }}
            </n-button>
          </div>
          <div class="inline-block mt-4 py-1 text-xl border-b-2 border-dashed border-gray-300">
            教材领用
          </div>
          <div class="flex items-center justify-center mb-8 mt-14">
            <div class="qrcode text-center">
              <div id="qrcode"></div>
              <!--<img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/qrcode.jpg" alt="二维码" />-->
              <p class="mt-1">教材领用二维码</p>
            </div>
            <p class="ml-8">
              请
              <span style="color: #ea4c00">班主任</span>
              使用<span style="color: #ea4c00">智慧人才APP</span>
              扫描教材领用二维码进行领用教材
            </p>
          </div>
        </div>
      </div>
    </NSpin>
  </Layout>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Layout from '@/components/Layout';
import { getUserInfoApi, teachingMaterialsVerifyApi } from '@/api';
import { nextTick, reactive, ref } from 'vue';
import QRCode from 'qrcodejs2';

const flag = ref(true);
teachingMaterialsVerifyApi().then(res => {
  flag.value = res.data;
});

const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';
const userInfo = reactive({});
const initLoading = ref(true);
getUserInfoApi()
  .then(res => res.data)
  .then(res => {
    const { photo, stuName, tenantName, className, headTeacherName, teachingMaterialsDate, id } =
      res;
    Object.assign(userInfo, {
      photo,
      stuName,
      tenantName,
      className,
      headTeacherName,
      teachingMaterialsDate,
      id,
    });
    renderQrcode();
  })
  .finally(() => (initLoading.value = false));

function renderQrcode () {
  new QRCode('qrcode', {
    width: 180,
    height: 180,
    text: userInfo.id,
  });
}

const router = useRouter();
function gotoHome () {
  router.push('/');
}
</script>

<style lang="scss" scoped>
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}
.qrcode > img {
  width: 170px;
  height: 176px;
  margin-bottom: 5px;
}
</style>
